import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BaseUrlService } from './base-url.service';

@Injectable()
export class NewTabService {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private baseUrlService: BaseUrlService
    ) {}

    public open(url: string): void {
        const e = this.document.createElement('a');
        e.href = `${this.baseUrlService.baseUrl}${url}`;
        e.target = '_blank';
        e.rel = 'noreferrer';
        e.click();
        e.remove();
    }
}
